export const invoiceDraftKey = (row) => JSON.stringify([row.transaction_id, row.invoice_no]);

export const mergePendingInvoiceDrafts = (rows, pending) => rows?.map((row) => {
  const key = invoiceDraftKey(row);
  const saved = pending.get(key);
  if (!saved) return row;
  if (Object.keys(saved).every((field) => row[field] === saved[field])) {
    pending.delete(key);
    return row;
  }
  return { ...row, ...saved };
});

export const savedInvoiceFields = (row) => Object.fromEntries([
  'total_amount', 'total_pay_amount', 'max_wht_rate', 'total_wht_amount',
  'fee', 'price_gl_diff', 'add_gl_diff', 'isSendMail',
].map((field) => [field, row[field]]));
